export function createTenantRegistryClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * One page of the platform's tenants, newest first
         *
         * Requires scope: tenant:read:any
         */
        listTenants(limit, after, status, options) {
            return transport.request({
                method: "GET",
                path: "/v1/tenants",
                query: { limit: limit, after: after, status: status },
                options,
            });
        },
        /**
         * POST /v1/tenants
         *
         * Requires scope: tenant:create
         */
        createTenant(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/tenants",
                body,
                options,
            });
        },
        /**
         * GET /v1/tenants/{tenantId}
         *
         * Requires scope: tenant:read, tenant:read:any
         */
        getTenant(tenantId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/tenants/{tenantId}/status
         *
         * Requires scope: tenant:lifecycle
         */
        transitionTenantStatus(tenantId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/status`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=tenant-registry.js.map